import { Component, signal } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { SectionService } from '../../../../services/section.service';
import { Client, Section, SectionStudentEnrollment } from '@mira-avant/mtlibs';
import { ClientService } from '../../../../services/client.service';
import { SectionsTable } from './sections-table/sections-table';
import { EnrollmentTable } from './enrollment-table/enrollment-table';

@Component({
	selector: 'app-section-enrollment-editor',
	imports: [AngularModule, SectionsTable, EnrollmentTable],
	standalone: true,
	templateUrl: './section-enrollment-editor.html',
	styleUrl: './section-enrollment-editor.scss',
})
export class SectionEnrollmentEditor {
	public clientUuid = signal<string | undefined>(undefined);
	public selectedSection = signal<Section | null>(null);
	public enrollment = signal<SectionStudentEnrollment[]>([]);
	public loading = signal<boolean>(false);

	constructor(
		public sectionService: SectionService,
		private clientService: ClientService
	) {
		this.clientService.getClientBySubDomain$().then((client: Client | null) => {
			if (client) {
				this.clientUuid.set(client.uuid);
			}
		});
	}

	public async onSectionSelected(section: Section | null): Promise<void> {
		this.selectedSection.set(section);

		if (!section?.uuid) {
			this.enrollment.set([]);
			return;
		}

		const enrollmentData = await this.sectionService.getEnrollment(section.uuid);
		this.enrollment.set(enrollmentData);
	}

	public async onSaveEnrollment(enrollment: SectionStudentEnrollment[]): Promise<void> {
		const currentSection = this.selectedSection();
		if (!currentSection) {
			return;
		}

		this.loading.set(true);

		try {
			await this.sectionService.updateEnrollment(currentSection.uuid, enrollment);
		} finally {
			this.loading.set(false);
		}
	}
}
